import { SubmitHandler, useForm } from "react-hook-form";
import { MsgError, MsgLoading, MsgSuccess } from "../../../components/Loaders/MessageLoaders";
import AmenitiesService from "../../../services/AmenitiesService";

export type AmenitiesInput = {
    id?: string,
    amenity: string,
    amenity_icon: any
}

const TabAddAmenities = () => {
    // const [isTranslationActive, setIsTranslationActive] = useState(false)

    const { register, handleSubmit, watch, formState: { errors }, reset } = useForm<AmenitiesInput>();
    const onSubmit: SubmitHandler<AmenitiesInput> = async (data) => {
        try {
            data['amenity_icon'] = data.amenity_icon[0]
            MsgLoading()
            const multipart = true
            const response = await AmenitiesService.createAmenity(data, multipart)
            MsgSuccess(response.data.msg)
            reset()
        } catch (error: any) {
            if (error.response) {
                MsgError(error.response.data.message)
            }
        }
    }
    return (
        <div>
            {/* {isTranslationActive ? <p className='text-gray-600 mt-8'>Click to add category with <span className='text-primary-base underline cursor-pointer' onClick={() => setIsTranslationActive(false)}> base language </span></p> :
                <p className='text-gray-600 mt-8'>To add translation click <span className='text-primary-base underline cursor-pointer' onClick={() => setIsTranslationActive(true)}> translated package category</span></p>} */}

            <div className="my-4">
                <form action="w-fit my-10 lg:mt-96" onSubmit={handleSubmit(onSubmit)}>
                    <div className="flex flex-col space-y-3 my-4">
                        <label htmlFor="amenity">Select Package Type</label>
                        <input type="text" id="amenity" className='form-input inputs md:w-96'  {...register("amenity", { required: true })} />
                        {errors.amenity && <span className='text-red-500'>This field is required</span>}
                    </div>

                    <div className="flex flex-col space-y-3 my-4">
                        <label htmlFor="amenity_icon">Package Category</label>
                        <input type="file" id="amenity_icon" className='form-input inputs md:w-96' required placeholder='Enter a package category....' {...register("amenity_icon", { required: true })} />
                        {errors.amenity_icon && <span className='text-red-500'>This field is required</span>}
                    </div>

                    <div className="flex flex-col space-y-3 my-4">
                        <input type="submit" className='btn btn-primary' value='Submit' />
                    </div>

                </form>
            </div>
        </div>
    )
}

export default TabAddAmenities